import $ from 'jquery';
import ko from '@tko/build.knockout';
import _ from 'lodash';
import moment from 'moment-timezone';
import numeral from 'numeral';
import TemplateCommon from '../helpers/template-common';

var instance = null;

function FormatterCommon() {
    if (instance !== null) {
        throw new Error('Cannot instantiate more than one FormatterCommon.');
    }

    var self = this;

    var GREEN = self.GREEN = "var(--good-color)";
    var RED = self.RED = "var(--bad-color)";
    var YELLOW = self.YELLOW = "#db8b0b";

    self.jitterColorBands = [{ min: 0, max: 20, color: GREEN, ind: 1 }, {
        min: 21,
        max: 60,
        color: YELLOW,
        ind: 2
    }, { min: 61, max: 10000, color: RED, ind: 3 }];

    self.packetLossColorBands = [{ min: 0.0, max: 0.50, color: GREEN, ind: 1 }, {
        min: 0.51,
        max: 2.0,
        color: YELLOW,
        ind: 2
    }, { min: 2.01, max: 1000.0, color: RED, ind: 3 }];
}

function formatDateTime(date, format) {
    return moment.utc(date).format(format);
}

FormatterCommon.prototype = {
    dispose: function () {},

    sanitizeString: function (stringToSanitize) {
        return _.escape(stringToSanitize);
    },

    sanitizeObject: function (objectToSanitize) {
        var self = this;
        _.forEach(_.keys(objectToSanitize), function (key) {
            objectToSanitize[key] = self.sanitize(objectToSanitize[key])
        })

        return objectToSanitize;
    },

    sanitize: function (itemToSanitize) {
        if (_.isNull(itemToSanitize) || _.isEmpty(itemToSanitize)) {
            return itemToSanitize;
        } else if (_.isString(itemToSanitize)) {
            return this.sanitizeString(itemToSanitize);
        } else if (_.isObject(itemToSanitize)) {
            return this.sanitizeObject(itemToSanitize);
        }
        return itemToSanitize;
    },

    formatHour: function (date) {
        return formatDateTime(date, "HH:mm");
    },

    formatDate: function (date) {
        return formatDateTime(date, "YYYY-MM-DD");
    },

    formatNumeric: function (value, toString) {
        return (Number(value) % 1 === 0) ? parseInt(value) : (toString ? parseFloat(value).toFixed(2) : _.round(parseFloat(value), 2));
    },

    getColorForPercentage: function (value) {
        var self = this;

        if ((value === null) || isNaN(value) || (!$.isNumeric(value))) {
            return "";
        }

        if (value <= 1) {
            value = Math.round(value * 100);
        }

        var colorband = [
            { "lo": 0, "hi": 60, "color": self.GREEN },
            { "lo": 60, "hi": 80, "color": self.YELLOW },
            { "lo": 80, "hi": 100, "color": self.RED }
        ];

        var bg = "";

        for (var i = 0; i < colorband.length; i++) {
            var band = colorband[i];
            if ((value >= band.lo) && (value <= band.hi)) {
                bg = band.color;
                break;
            }
        }

        return bg;
    },

    getColorSectorsForGauge: function (setnumber) {
        var self = this;

        if (!setnumber) {
            return [
                { "lo": 0, "hi": 60, "color": self.GREEN },
                { "lo": 60, "hi": 80, "color": self.YELLOW },
                { "lo": 80, "hi": 100, "color": self.RED }
            ];

        } else {
            return [
                { "lo": 0, "hi": 20, "color": self.RED },
                { "lo": 20, "hi": 40, "color": self.YELLOW },
                { "lo": 40, "hi": 100, "color": self.GREEN }
            ];
        }
    },

    getIcon: function (itemtype) {
        var icon = "";
        switch (itemtype.toUpperCase()) {
            case 'BJN':
                icon = '<img title="Bluejeans" src="dist/images/bluejeans.png" width="32px"/>';
                break;
            case 'CTPS':
            case 'CUCM':
            case 'MCU':
            case 'VCS':
            case 'VCSX':
            case 'ACANO':
            case 'CMS':
                icon = '<img title="Cisco" src="dist/images/cisco.png" width="32px"/>';
                break;

            case 'DMA':
            case 'RMX':
                icon = '<img title="Polycom" src="dist/images/polycom_logo.jpg" width="32px"/>';
                break;

            case 'PEXIP':
                icon = '<img title="Pexip" src="dist/images/pexip.png" width="32px"/>';
                break;

            case 'SKYPE':
                icon = '<img title="Skype" src="dist/images/skype-icon-logo.png" width="32px"/>';
                break;

            case 'ZOOM':
                icon = '<img title="Zoom" src="dist/images/zoom.png" width="32px"/>';
                break;

            default:
                icon = "";
        }
        return icon;
    },

    getFormattedNumber: function(value, useAbbreviation) {
        if (typeof value === 'string' && value.includes('E')) {
            try {
                value = Number(value);
            } catch (e) {
                console.log('unable to convert exponent value into number', value);
            }
        }
        var num = numeral(value);

        if (!useAbbreviation) {
            return num.format('0,0.[00]'); // default format for non-abbreviated formatting
        }

        var numValue = num.value();
        var format;

        if (numValue < 10) {
            format = '0[.]0'; // one decimal
        }
        else if (numValue <= 9999) {
            format = '0,0'; // comma separated
        }
        else {
            format = '0[.]0a'; // abbreviated numeral
        }
        return num.format(format);
    },

    getQualityStringFromIndicator: function (qualityIndicator) {
        var qualityStr;

        switch (qualityIndicator) {
            case 1:
                qualityStr = "GOOD";
                break;

            case 2:
                qualityStr = "FAIR";
                break;

            case 3:
                qualityStr = "BAD";
                break;

            default:
                qualityStr = "";
                break;
        }

        return qualityStr;
    },

    getSpanTitle: function (val) {
        return TemplateCommon.getSpanWithContentAndAttrs(val, { title: val });
    },

    shiftValues: function (list, values) {
        for (var i = 0; i < list.length; i++) {
            var innerlist = list[i];

            if ($.isArray(values[i])) {
                for (var j = 0; j < values[i].length; j++) {
                    innerlist.shift();
                    innerlist.push(values[i][j]);
                }

            } else {
                innerlist.shift();
                innerlist.push(values[i]);
            }
        }

        return list;
    },

    sortUnique: function (array, lowercase) {
        if (lowercase) {
            return _.chain(array).map(_.toLower).sortBy().uniq().value();
        }
        return _.chain(array).sortBy().uniq().value();
    },

    transformHeaders: function (headers, group, metric) {
        if (!group && !metric) {
            return headers;
        }

        var headerDescription = { periodStartDate: 'Period Start Date' };

        return headers.map(function (header) {
            if (header === 'aggregateFact' && metric) {
                return metric.columnDescription;
            }

            if (group && group.columnName === header) {
                return group.columnDescription;
            }

            if (headerDescription[header]) {
                return headerDescription[header];
            }

            return header;
        });
    },

    truncatedISODateTimeToUnixEpoch: function (dateTime) {
        /**
         * Date times come from the server as improper ISO-8601 datetimes (e.g. 2016-12-01T00:00:00, missing 'Z' at the end).
         * Since the datetime string does not conform to the ISO-8601 format the Date function may fall back to any
         * implementation-specific heuristics or implementation-specific date formats. This causes date parsing inconsistency
         * across browsers. We leverage MomentJS because it takes care of cross-browser date-parsing issues and parses it correctly.
         *
         * http://stackoverflow.com/questions/15109894/new-date-works-differently-in-chrome-and-firefox
         */
        return moment.parseZone(dateTime).unix() * 1000;
    },

};

FormatterCommon.getInstance = function() {
    if (instance === null) {
        instance = new FormatterCommon();
    }
    return instance;
};

export default FormatterCommon.getInstance();
